import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import DataTable from 'react-data-table-component-with-filter'

const TraidList = ({
  selectedTraidList,
  setSelectedTraidList,
  selectedPresetChangeLoading,
  runTraits,
  getAvailableTraits,
  selectedPreset,
  onTraitClick,
  onClose
}) => {
  const [tableMaxHeight, setTableMaxHeight] = useState(500)
  const [filteredData, setFilteredData] = useState(runTraits)
  const [hideNull, setHideNull] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    setFilteredData(runTraits)
  }, [runTraits])

  useEffect(() => {
    if (hideNull) {
      const filtered = runTraits.filter((item) => item.prsScore !== null)
      setFilteredData(filtered)
    } else {
      setFilteredData(runTraits)
    }
  }, [hideNull])

  useEffect(() => {
    const updateHeight = () => {
      const headerHeight = 250 // üstteki input, buton vs.
      const availableHeight = window.innerHeight - headerHeight
      setTableMaxHeight(availableHeight)
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  const handleChange = ({ selectedRows }) => {
    setSelectedTraidList(selectedRows)
  }
  
  const columns = [
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      filterable: false,
      width: '200px',
    },
    {
      name: 'Score',
      selector: (row) => row.prsScore,
      sortable: true,
      filterable: false,
      width: '100px',
      cell: (row) => {
        return (
          <span
            className={clsx('badge', {
              'badge-secondary': row.prsScore === null,
              'badge-danger': row.prsScore !== null && row.prsScore <= 1,
              'badge-warning': row.prsScore !== null && row.prsScore < 1.3 && row.prsScore > 1,
              'badge-success': row.prsScore !== null && row.prsScore >= 1.3,
            })}
          >
            {row.prsScore === null ? (
              'N/A'
            ) : (
              <>
                PRS = {row.prsScore.toFixed(2)}{' '}
                {row.prsScore < 1 ? (
                  <i
                    className='fa fa-chevron-down'
                    style={{
                      color: 'white',
                      marginLeft: 5,
                    }}
                  ></i>
                ) : row.prsScore < 1.3 ? (
                  <span
                    style={{
                      marginLeft: 5,
                      fontWeight: 'bold',
                    }}
                  >
                    {`-`}
                  </span>
                ) : (
                  <i
                    className='fa fa-chevron-up'
                    style={{
                      color: 'white',
                      marginLeft: 5,
                    }}
                  ></i>
                )}
              </>
            )}
          </span>
        )
      },
    },
  ]

  return (
      <>
        <div className="modal-header">
          <h5 className="modal-title">Trait List</h5>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="modal-body">
          <div className="d-flex gap-3 mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search Trait..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value)
                setFilteredData(
                  runTraits.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
                )
              }}
            />
            <div className="form-check form-switch">
              <label className="form-check-label me-2">Hide N/A</label>
              <input
                className="form-check-input mt-3"
                type="checkbox"
                checked={hideNull}
                onChange={(e) => setHideNull(e.target.checked)}
              />
            </div>
          </div>

          {selectedPresetChangeLoading ? (
            <div className="text-center py-5">
              <div className="spinner-grow text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <DataTable
              className="table-striped"
              pagination
              responsive
              fixedHeader
              fixedHeaderScrollHeight={`${tableMaxHeight - 330}px`}
              columns={columns}
              data={filteredData}
              onSelectedRowsChange={handleChange}
              onRowClicked={async (row) => {
                if (row.prsScore !== null) {
                  await getAvailableTraits(row)
                  onTraitClick()
                  // onClose()
                }
              }}
            />
          )}
        </div>
      </>
  )
}

export { TraidList }
